var DrawerPosition;
(function (DrawerPosition) {
    DrawerPosition["Left"] = "left";
    DrawerPosition["Right"] = "right";
})(DrawerPosition || (DrawerPosition = {}));
export default DrawerPosition;
